import {
  Button,
  DateRangeSelector,
  ENUM_DATE_RANGE,
  ToastMessage,
  getDateRangeSelector
} from '@cokitchen/cokitchen-components';
import LocalModal from 'components/base/local-modal';
import React, { FC, useState } from 'react';
import { ReactComponent as ExportIcon } from 'assets/icons/export-blue-icon.svg';
import { toast } from 'react-toastify';
import { apiService } from 'services/base.service';
import { STORAGE_KEYS } from 'utils/constants';

type exportModalProps = {
  show: boolean;
  onClose: () => void;
};
const ExportProductionReportModal: FC<exportModalProps> = ({ show, onClose }) => {
  const [filters, setFilters] = useState({
    dateRange: getDateRangeSelector(ENUM_DATE_RANGE.THIS_WEEK)
  });
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState(localStorage.getItem(STORAGE_KEYS.EMAIL) ?? '');
  const cokitchenId = localStorage.getItem(STORAGE_KEYS.COKITCHEN);
  const { startDate: start_date, endDate: end_date } = filters.dateRange;

  const onConfirm = async () => {
    const data = {
      email: email,
      start_time: start_date,
      end_time: end_date,
      cokitchen_id: cokitchenId
    };
    try {
      setLoading(true);
      await apiService.post('production-history/productions/report', { data });
      toast(<ToastMessage type='success' message='Production report successfully sent' />);
      onClose();
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };

  return (
    <LocalModal
      isOpen={show}
      onRequestClose={onClose}
      contentClassName='!max-w-[420px]'
      footer={
        <div className='flex gap-4 justify-center'>
          <button
            onClick={onClose}
            className='bg-[#F2F2F2] text-[#2E3031] font-medium rounded-[100px] h-[41px] w-[139px]'>
            Cancel
          </button>
          <Button
            loading={loading}
            onClick={onConfirm}
            color='primary'
            small
            variant='block'
            className='h-[41px] w-[139px]'>
            Confirm
          </Button>
        </div>
      }>
      <div className='flex flex-col justify-center items-center max-w-[240px] mx-auto'>
        <div className='bg-[#E5F4FF] w-[100px] h-[100px] rounded-full flex items-center justify-center'>
          <ExportIcon />
        </div>
        <h3 className='text-lg font-medium mt-2 mb-4'>Export production report</h3>
        <label className='self-start text-sm' htmlFor=''>
          Email
        </label>
        <input
          type='email'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className='mt-1 text-sm border w-full h-[36px] px-3 py-1.5 text-[#5E6164] rounded-lg  border-[#E5E6E6] focus:outline-none'
        />
        <DateRangeSelector
          defaultRange={ENUM_DATE_RANGE.THIS_WEEK}
          onChange={(v) => setFilters({ ...filters, dateRange: v.date })}
          className='text-[#5E6164] w-[240px] h-[36px] text-sm border-[#E5E6E6] mt-6'
          isInput
        />
      </div>
    </LocalModal>
  );
};

export default ExportProductionReportModal;
